export default "__VITE_ASSET__B2lhq93U__"